import { Page } from '../components/Layout';
import { navigate } from '../lib/router';
import { t } from '../i18n';

export function NotFound() {
  return (
    <Page>
      <div className="card p-6">
        <h1 className="text-2xl font-semibold tracking-tight">{t('notFound.title')}</h1>
        <button type="button" onClick={() => navigate('/')} className="btn btn-primary mt-5">
          {t('notFound.home')}
        </button>
      </div>
    </Page>
  );
}
